import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
var colors = {
  error: 'negative',
  warning: 'warn',
  info: 'accent1',
  success: 'positive'
};
export var Line = styled.div.withConfig({
  displayName: "partials__Line",
  componentId: "sc-6tdm3r-0"
})(["flex-shrink:0;width:5px;border-radius:2.5px;background-color:", ";", ""], function (_ref) {
  var theme = _ref.theme,
    type = _ref.type;
  return theme.colors[colors[type]];
}, function (_ref2) {
  var withIcon = _ref2.withIcon;
  return !withIcon ? 'margin-right: 12px;' : '';
});
export var IconBlock = styled.div.withConfig({
  displayName: "partials__IconBlock",
  componentId: "sc-6tdm3r-1"
})(["display:flex;align-items:center;justify-content:center;margin:0 14px;svg{stroke:", ";}"], function (_ref3) {
  var theme = _ref3.theme,
    type = _ref3.type;
  return theme.colors[colors[type]];
});
export var ContentBlock = styled.div.withConfig({
  displayName: "partials__ContentBlock",
  componentId: "sc-6tdm3r-2"
})(["padding:6px 0;"]);
export var Title = styled.div.withConfig({
  displayName: "partials__Title",
  componentId: "sc-6tdm3r-3"
})(["", " margin-bottom:4px;font-weight:500;"], getFont(1, 'compact'));
export var Subtitle = styled.div.withConfig({
  displayName: "partials__Subtitle",
  componentId: "sc-6tdm3r-4"
})(["", " color:", ";"], getFont(0, 'compact'), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.fontL;
});
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-6tdm3r-5"
})(["display:flex;padding:8px 9px 8px 6px;border:1px solid ", ";border-radius:", ";box-shadow:rgb(34 34 90 / 0.1) 0 0 4px,rgb(0 0 0 / 0.07) 0 0 3px;background-color:#fff;", "{width:", ";}", "{margin:0 ", ";}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.uiL;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.borderRadius;
}, Line, function (_ref7) {
  var sizeParams = _ref7.sizeParams;
  return sizeParams.lineWidth;
}, IconBlock, function (_ref8) {
  var sizeParams = _ref8.sizeParams;
  return sizeParams.iconMargin;
});